import React from 'react';

export default function Avatar({image, width, alt=""}) {
  return (
    <img src={image} style={{width: width, height: width, borderRadius: '50%'}} alt={alt} />
  )
}
